import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useApp } from "@/context/AppContext";

export const Footer = () => {
  const { data } = useApp();
  const s = data.settings || {};
  return (
  <footer className="relative mt-24 border-t border-[var(--border-subtle)] bg-[var(--bg-card)]" data-testid="main-footer">
    <div className="container-arch py-16">
      <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <p className="font-serif text-2xl font-light leading-snug text-[var(--text-primary)]">ARCHEDIA <span className="text-[var(--accent-gold)]">SOLUTIONS</span></p>
          <p className="mt-4 max-w-sm font-serif text-xl font-light italic leading-snug text-[var(--text-primary)]">
            {s.tagline || "Perspective Builds Possibilities."}
          </p>
          <p className="mt-4 max-w-sm text-sm text-[var(--text-muted)]" data-testid="footer-blurb">
            {s.footerBlurb || "A premium real-estate advisory and decision platform."}
          </p>
        </div>

        <div>
          <div className="overline mb-4">Ecosystem</div>
          <ul className="space-y-2.5 text-sm text-[var(--text-muted)]">
            <li><Link to="/living" className="hover:text-[var(--accent-gold)]">Archedia Living</Link></li>
            <li><Link to="/invests" className="hover:text-[var(--accent-gold)]">Archedia Invests</Link></li>
            <li><Link to="/luxe" className="hover:text-[var(--accent-gold)]">Archedia Luxe</Link></li>
            <li><Link to="/properties" className="hover:text-[var(--accent-gold)]">Properties</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-4">Company</div>
          <ul className="space-y-2.5 text-sm text-[var(--text-muted)]">
            <li><Link to="/about" className="hover:text-[var(--accent-gold)]">About</Link></li>
            <li><Link to="/contact" className="hover:text-[var(--accent-gold)]">Contact</Link></li>
            <li><Link to="/request" className="hover:text-[var(--accent-gold)]">Find My Property</Link></li>
            <li><Link to="/blog" className="hover:text-[var(--accent-gold)]">Blogs</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-4">Talk to Archedia</div>
          <p className="text-sm text-[var(--text-muted)]" data-testid="footer-address">{s.address || "Bengaluru, India"}</p>
          {s.email && <p className="mt-2 text-sm text-[var(--text-muted)]" data-testid="footer-email">{s.email}</p>}
          {s.phone && <p className="mt-1 text-sm text-[var(--text-muted)]" data-testid="footer-phone">{s.phone}</p>}
          <Link to="/contact" className="btn-outline-gold mt-5 !py-2.5 text-xs">
            Talk to Archedia <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </div>

      <div className="mt-14 hairline" />
      <div className="mt-6 flex flex-col items-center justify-between gap-3 text-xs text-[var(--text-muted)] sm:flex-row">
        <p>© {new Date().getFullYear()} {s.companyName || "Archedia Solutions"}. All rights reserved.</p>
        <p>Perspective visuals are illustrative Archedia evaluation data, not objective market guarantees.</p>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
